import { render, staticRenderFns } from "./WfUserDevCollectionForm.vue?vue&type=template&id=c77f72e6&"
import script from "./WfUserDevCollectionForm.vue?vue&type=script&lang=js&"
export * from "./WfUserDevCollectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports